import { dehydrate, QueryClient } from "@tanstack/react-query";
import { GetStaticProps, NextPage } from "next";

import DefaultLayout from "@/components/layouts/DefaultLayout";
import Courses from "@/components/views/Courses";
import { getCourses } from "@/services/DefaultService";
import SinglePageService from "@/services/SinglePageService";

const Index: NextPage<{ home: any }> = ({ home }) => {
  return (
    <DefaultLayout seo={home.attributes.seo}>
      <Courses home={home} />
    </DefaultLayout>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  const home = await SinglePageService.getPage({
    contentType: "courses-home",
  });
  const queryClient = new QueryClient();
  const pagination = {
    page: 1,
    pageSize: 10,
  };
  const sort = ["createdAt:desc"];
  await queryClient.prefetchQuery(["getCourses", pagination, sort], () =>
    getCourses({
      key: "getCourses",
      pagination,
      sort,
    })
  );

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      home,
    },
  };
};

export default Index;
